export const STARTING_SHOE_INDEX = 4;
